import axios from 'axios';
import Cookie from 'cookies-js';
import {
  ADD_CARD_DETAILS_SUCCESS,
  ADD_CARD_DETAILS_ERROR,
  DELETE_ADD_CARD_DETAILS_ERROR,
  ADD_IS_LOADING
} from '../types';
import logoutAction from '../auth.actions/logout.action';

export const addCardDetailsSuccess = addCardDetails => ({
  type: ADD_CARD_DETAILS_SUCCESS,
  addCardDetails
});

export const addCardDetailsError = error => ({
  type: ADD_CARD_DETAILS_ERROR,
  error
});

export const deleteAddCardDetailError = () => ({
  type: DELETE_ADD_CARD_DETAILS_ERROR
});

const addCardisLoading = () => ({
  type: ADD_IS_LOADING
});

const addCardDetails = (cardDetails, history) => (dispatch) => {
  dispatch(addCardisLoading());
  return axios.post(`${process.env.REACT_APP_INNSTA_PAY_URL}/card/charge`, cardDetails, {
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_INNSTA_PAY_TOKEN}`
    }
  }).then((response) => {
    dispatch(addCardisLoading());
    Cookie.set('ref', response.data.ref);
    const { action } = response.data;
    if (action === 'otp') {
      return history.push('/add-card-otp');
    }
  }).catch((error) => {
    dispatch(addCardisLoading());
    if (error.response === undefined) {
      window.location.href = '/error';
    }
    if (error.response.status === 401) {
      const { status } = error.response;
      dispatch(logoutAction(status));
    }
    const { data } = error.response;
    dispatch(addCardDetailsError(data.message));
    throw error;
  });
};

export default addCardDetails;
